export default "__VITE_ASSET__BfbkAgPE__"